/**
 * Private modules
 */
const {
  alias,
  createQueryComponent,
  customerId,
  isSelected,
  objectId,
  objectIds,
  percent,
  systemGameId,
} = require('../.private').components;

/**
 * Scopes
 */
const {
  CUSTOMER_RUNNER_TICKET_HOOKS_ARCHIVED_BY_SYSTEM_GAME_ID,
  CUSTOMER_RUNNER_TICKET_HOOKS_INPUT_BY_SYSTEM_GAME_ID,
  DEFAULT,
} = require('../../scopes');

module.exports = {
  archiveCustomerRunnerTicketHooksBySystemGameId: {
    properties: {
      body: {
        properties: {
          objectIds,
        },
        required: ['objectIds'],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  copyCustomerRunnerTicketHooksBySystemGameId: {
    properties: {
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
    },
    required: ['params'],
    type: 'object',
  },
  createCustomerRunnerTicketHookBySystemGameId: {
    properties: {
      body: {
        properties: {
          alias,
          entries: {
            items: {
              properties: {
                objectId: {
                  oneOf: [
                    {
                      pattern: '^\\d+$',
                      type: 'string',
                    },
                    {
                      type: 'number',
                    },
                  ],
                },
                percent,
              },
              required: [
                'objectId',
                'percent',
              ],
              type: 'object',
            },
            minItems: 1,
            type: 'array',
            uniqueItems: true,
          },
        },
        required: [
          'alias',
          'entries',
        ],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  deleteCustomerRunnerTicketHooksBySystemGameId: {
    properties: {
      body: {
        properties: {
          objectIds,
        },
        required: ['objectIds'],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  getCustomerRunnerTicketHooksBySystemGameId: {
    properties: {
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
      query: createQueryComponent([
        CUSTOMER_RUNNER_TICKET_HOOKS_ARCHIVED_BY_SYSTEM_GAME_ID,
        CUSTOMER_RUNNER_TICKET_HOOKS_INPUT_BY_SYSTEM_GAME_ID,
        DEFAULT,
      ]),
    },
    required: [
      'params',
      'query',
    ],
    type: 'object',
  },
  unarchiveCustomerRunnerTicketHooksBySystemGameId: {
    properties: {
      body: {
        properties: {
          objectIds,
        },
        required: ['objectIds'],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          systemGameId,
        },
        required: [
          'customerId',
          'systemGameId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
  updateCustomerRunnerTicketHookById: {
    properties: {
      body: {
        properties: {
          alias,
          isSelected,
        },
        required: [
          'alias',
          'isSelected',
        ],
        type: 'object',
      },
      params: {
        properties: {
          customerId,
          objectId,
        },
        required: [
          'customerId',
          'objectId',
        ],
        type: 'object',
      },
    },
    required: [
      'body',
      'params',
    ],
    type: 'object',
  },
};
